import moment from "moment";

export const FILTER_ACTION = "SET_CURRENT_FILTERS";
export const FILTER_ACTION_RESET = "SET_RESET_FILTERS";

const initalDate = (type) => {
  const date = new Date();
  if (type == "from") {
    date.setDate(date.getDate() - 7);
    return date.toISOString().split('T')[0];
  } else if (type == "to") {
    const d = moment(date).format("YYYY-MM-DD")
    return d
  }

}

const initialFilterState = {
  commonFilters: {
    fromDate: initalDate("from"),
    toDate: initalDate("to"),
    nbfcId: "",
    productId: ""
  }
};

export const CommonFilterReducer = (state = initialFilterState, action) => {
  switch (action.type) {
    case FILTER_ACTION:
      return {
        ...state,
        commonFilters: {
          ...state.commonFilters,
          ...action.payload
        }
      };
    case FILTER_ACTION_RESET:
      return {
        commonFilters: { ...initialFilterState.commonFilters }
      };
    default:
      return state;
  }
};
